import { render, staticRenderFns } from "./resourceManage.vue?vue&type=template&id=44cbfa99&scoped=true&"
import script from "./resourceManage.vue?vue&type=script&lang=js&"
export * from "./resourceManage.vue?vue&type=script&lang=js&"
import style0 from "./resourceManage.vue?vue&type=style&index=0&id=44cbfa99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cbfa99",
  null
  
)

export default component.exports